var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthyBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1171,
    height: 794,
    viewBox: "0 0 1171 794",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1177 450V457.172C1142.79 498.412 1096.49 534.496 1039.02 564.753C945.961 613.613 825.538 645.663 681.167 659.783C519.234 675.696 394.477 722.091 318.3 758.175C271.089 780.588 236.194 801.88 214.983 816H207C227.755 801.88 264.703 778.571 316.248 754.141C392.881 717.832 518.093 671.214 680.71 655.301C824.397 641.181 944.364 609.355 1036.96 560.719C1095.81 529.789 1142.79 492.584 1177 450Z",
    fill: "#B9CCEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1198 345V353.936C1159.77 405.316 1108.03 450.274 1043.8 487.971C939.808 548.846 805.232 588.777 643.893 606.369C462.929 626.195 323.51 683.998 238.381 728.956C185.621 756.88 146.625 783.408 122.921 801H114C137.194 783.408 178.484 754.367 236.087 723.93C321.726 678.693 461.655 620.611 643.384 600.784C803.957 583.192 938.024 543.54 1041.5 482.945C1107.26 444.41 1159.77 398.056 1198 345Z",
    fill: "#B9CCEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M628.765 606.511C913.197 538.798 1118.31 375.581 1086.9 241.953C1055.49 108.326 799.443 54.8916 515.01 122.604C230.578 190.316 25.4648 353.534 56.8773 487.161C88.2898 620.788 344.333 674.223 628.765 606.511Z",
    stroke: "#C7D7D1",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthyBg);
export default __webpack_public_path__ + "static/media/healthyBg.44732a2ca40a9aaf32978318609d9b3d.svg";
export { ForwardRef as ReactComponent };